import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { TextFieldWithoutBorders } from "../../components/TextFieldWithoutBorders";
import { TextAreaWithoutBorders } from "../../components/TextAreaWithoutBorders";
import ProgressBar from "../../components/ProgressBar";
import { useDispatch, useSelector } from "react-redux";
import { GoalsWrapper } from "../GoalsWrapper";
import { NoGoalsCard } from "../../components/NoGoalsCard";
import KPIsTable from "../../components/KPIsTable";
import GoalProjectsTable from "../../components/GoalProjectsTable";
import './styles.css';
import YearFromTo from "../../components/YearFromTo";
import PrivacySelector from "../../components/PrivacySelector";
import GoalsBreadCrumb from "../GoalsBreadCrumb";
import ButtonDefault from "../../components/ButtonDefault";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import NewAcademySubGoalPopper from "../NewAcademySubGoalPopper";
import { setGoals, setSelectedGoal, setSelectedSubGoal } from "../../redux/reducers/goalsAndStrategy";
import { getGoalDetail, getGoals, updateGoal } from "../../api/goals";
import StatusSelectBoxWithoutLabel from "../../components/StatusSelectBoxWithoutLabel";
import AvatarOwnerSelectBox from "../../components/AvatarOwnerSelectBox";
import StaffMultiSelectCheckBoxWithoutBorders from "../../components/StaffMultiSelectCheckBoxWithoutBorders";
import NewProjectDetailPopperGoals from "../NewProjectDetailPopperGoals";
import { getProjects } from "../../api/projects";
import ProjectDetails from "../ProjectDetails";
import StatusIndicatorSmall from "../../components/StatusIndicatorSmall";
import { calculateGoalProgress, getAverageProjectStatus } from "../../common/StaticExports";
import { deleteKpi } from "../../api/kpi";
import { colors } from "../../common/pallette/colors";
import CircularWithValueLabel from "../../components/CircularProgress";
import DepartmentSelectBox from "../../components/DepartmentSelectBox";
import { SwitchButton } from "../../components/SwitchButton";

const GoalDetails = (props:any) => {
    const selectedGoal = useSelector((state:any) => state.goalsAndStrategy.selectedGoal);
    const selectedSubGoal = useSelector((state:any) => state.goalsAndStrategy.selectedSubGoal);
    const [data, setData] = useState(selectedGoal == null ? selectedSubGoal : selectedGoal);
    const [fetchedDetails, setFetchedDetails] = useState(false);
    const [fetchedSubGoalsDetails, setFetchedSubGoalsDetails] = useState(false);
    const [isFetchingProjects, setIsFetchingProjects] = useState(false);
    const [t] = useTranslation();
    const goals = useSelector((state:any) => state.goalsAndStrategy.goals);
    const [isUpdatedData, setIsUpdatedData] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const clubDetails = useSelector((state:any) => state.clubDetails);
    const currentProject = useSelector((state:any) => state.actionPlan.selectedProject);
    const [addSubGoal, setAddSubGoal] = useState(false);
    const [addProject, setAddProject] = useState(false);
    const dispatch = useDispatch();
    const statuses = data?.subGoals ? data?.subGoals.map((item:any) => item.status) : [];
    const currentClub = useSelector((state:any) => state.clubDetails);
    const isAdmin = useSelector((state:any) => state.common.isAdmin);
    const isReadOnly = (isAdmin && selectedGoal?.clubId != 0);
    //managing redux state updates
    const handleChangeState = (updatedData:any) => {
        var tempObj = { ...data, ...updatedData };
        // dispatch(setSelectedGoal(tempObj));
        setData(tempObj);
        setIsUpdatedData(true);
    }
    //handling kpis
    const handleChangeKpis = (label:any, updatedValue:any, index:any) => {
        var tempKpis = data?.kpis ? data?.kpis : [];
        switch(label) {
            case 'addKpi':
                tempKpis = [...tempKpis, updatedValue];
                break;
            case 'deleteKpi':
                // tempKpis = tempKpis.splice(index, 1);
                if (updatedValue?.id != null && updatedValue?.id > 0) {
                    deleteKpi({ kpiId: updatedValue?.id })
                }
                tempKpis = tempKpis.filter((item:any, i:any) => index !== i);
                break;
            default:
                tempKpis = tempKpis.map((item:any, i:any) => {
                    if (i == index) {
                        return { ...item, [label]: updatedValue, goalId: data?.id };
                    } return item;
                });
                break;
        }
        const tempObj = {kpis: tempKpis};
        handleChangeState(tempObj);
    };
    //handling projects
    const handleChangeProjects = (label:any, updatedValue:any, index:any) => {
        var tempProjects = data?.projects ? data?.projects : [];
        switch(label) {
            case 'deleteProject':
            case 'archiveProject':
                tempProjects = tempProjects.filter((item:any, i:any) => index !== i);
                break;
        }
        const tempObj = {projects: tempProjects};
        handleChangeState(tempObj);
    };
    //managing sub goals
    const manageHandleClickAway = (newSubGoalData:any, isUpdatedData: boolean) => {
        if (newSubGoalData != null && isUpdatedData) {
            let subGoals = data?.subGoals ? data?.subGoals : [];
            const tempSubGoals = [...subGoals, newSubGoalData];
            var tempObj = { ...data, subGoals: tempSubGoals };
            setData(tempObj);
            updateGoalsList();
        }
        setAddSubGoal(false);
    }
    //managingProjects
    const manageHandleClickAwayProjects = (newProjectData:any, isUpdatedData: boolean) => {
        if (newProjectData != null && isUpdatedData) {
            let projects = data?.projects ? data?.projects : [];
            const tempProjects = [...projects, newProjectData];
            var tempObj = { ...data, projects: tempProjects };
            setData(tempObj);
            updateGoalsList();
        }
        setAddProject(false);
    }

    const updateGoalsList = async () => {
        const goalsFetch = await getGoals(!isAdmin && { clubId: currentClub?.id });
        dispatch(setGoals(goalsFetch));
    }
    const updateChanges = async () => {
        const kpiNames = data?.kpis?.map((d:any) => d.name);
        const kpiFrequency = data?.kpis?.map((d:any) => d.frequency);
        const kpiValues = data?.kpis?.map((d:any) => d.value);
        if(isUpdatedData && !isUpdating && !kpiNames?.includes(null) && !kpiFrequency?.includes(null) && !kpiValues.includes(null)) {
            setIsUpdating(true);
            const tempMembers = data?.members?.map((d:any) => typeof d == 'object' ? d.id : d);
            const tempSubGoals = data?.subGoals ? data?.subGoals : [];
            const tempkpis = data?.kpis ? data?.kpis.map((ki:any) => {return { ...ki, goalId: data?.id }}) : [];
            const tempObj = { ...data, members: tempMembers, subGoals: tempSubGoals, kpis: tempkpis };
            const response = await updateGoal({goalId: data?.id, goal: tempObj});
            if(selectedSubGoal !== null) {
                response && dispatch(setSelectedSubGoal({...tempObj, ...response}));
            } else {
                response && dispatch(setSelectedGoal({...tempObj, ...response}));
            }
            setIsUpdatedData(false);
            updateGoalsList();
            setIsUpdating(false);
        }
    }

    useEffect(() => {
        !isUpdating && isUpdatedData && updateChanges();
        !fetchedDetails && fetchGoaldetails();
        !fetchedSubGoalsDetails && selectedSubGoal && selectedSubGoal?.id && fetchSubGoaldetails();
        selectedSubGoal !== null ? setData(selectedSubGoal) : setData(selectedGoal);
        selectedSubGoal == null && setFetchedSubGoalsDetails(false);
    }, [ selectedGoal, selectedSubGoal ]);

    
    const fetchGoaldetails = async () => {
        setIsFetchingProjects(true);
        setFetchedDetails(true);
        const response = await getGoalDetail({ goalId: selectedGoal?.id });
        const projects = await getProjects({archivedStatus: 1, clubId: clubDetails?.id, pastStatusPeriod: 1, goalId: selectedGoal?.id });
        const tempObj = { ...response, projects: projects };
        dispatch(setSelectedGoal(tempObj));
        setIsFetchingProjects(false);
    }

    const fetchSubGoaldetails = async () => {
        setIsFetchingProjects(true);
        setFetchedSubGoalsDetails(true);
        const response = await getGoalDetail({ goalId: selectedSubGoal?.id });
        const projects = await getProjects({ archivedStatus: 1, clubId: clubDetails?.id, pastStatusPeriod: 1, goalId: selectedSubGoal?.id });
        const tempObj = { ...response, projects: projects };
        dispatch(setSelectedSubGoal(tempObj));
        setIsFetchingProjects(false);
    }

    return (
        <>
            <GoalsBreadCrumb />
            {
                selectedSubGoal != null &&
                <Box className='detailedGoalHeading' sx={{ bgcolor: colors.grey.bright }}>
                    <Typography className='detailedGoalTitle'>{selectedGoal?.name}</Typography>
                </Box>
            }
            {
                currentProject != null ?
                <>
                    <ProjectDetails />
                </> :
                <Box className={'goalDetailWrapper'} height={selectedSubGoal != null ? 'calc(100% - 72px)' : 'calc(100% - 10px)'}>
                    <NewAcademySubGoalPopper isOpen={addSubGoal} handleClickAway={manageHandleClickAway} parentGoal={data} />
                    <NewProjectDetailPopperGoals isOpen={addProject}  handleClickAway={manageHandleClickAwayProjects} goalId={data?.id}/>
                    <Box className={'gdLeftContent'}>
                        <Box className={'gdHeader mb20'}>
                            <Box sx={{ width: '70%' }}>
                                <TextFieldWithoutBorders
                                value={data?.name ? data?.name : ''}
                                handleChange={(e:any) => {handleChangeState({name: e.target.value})}}
                                placeholder={t('ENTER_GOAL_NAME')}
                                fontSize={'16px'}
                                fontWeight={700}
                                fullWidth={true}
                                manageOnBlur={updateChanges}
                                isReadOnly={isReadOnly}
                                />
                            </Box>
                            {
                                (data?.parentGoalId == null || data?.parentGoalId == 0) && data?.subGoals?.length > 0 ?
                                <StatusIndicatorSmall reportType={'rabg'} status={getAverageProjectStatus(statuses)}/>:
                                <StatusSelectBoxWithoutLabel 
                                value={data?.status}
                                manageSelect={handleChangeState}
                                manageOnBlur={updateChanges} />
                            }
                        </Box>
                        <Box className={'gdContents'}>
                            <Box className={'mb20'} sx={{ display: "flex", flexDirection: "row" }}>
                                <Box sx={{ width: '100%' }}>
                                    <Typography className="headingsGD">{t('DESCRIPTION')}</Typography>
                                    <TextAreaWithoutBorders
                                    value={data?.description ? data?.description : ''}
                                    handleChange={(e:any) => {handleChangeState({description: e.target.value})}}
                                    placeholder={t('ENTER_GOAL_DESCRIPTION')}
                                    manageOnBlur={updateChanges}
                                    isReadOnly={isReadOnly}
                                    />
                                </Box>
                                <Box sx={{ ml: '20px', mt: "20px", mb: "auto" }}>
                                    {
                                        (data?.parentGoalId == null || data?.parentGoalId == 0) &&
                                        <CircularWithValueLabel progress={(data?.parentGoalId == null || data?.parentGoalId == 0) && data?.subGoals?.length > 0 ?
                                        calculateGoalProgress(statuses) :
                                        data?.status != null ? calculateGoalProgress([data?.status]) : 0} 
                                        size={100}/>
                                    }
                                </Box>
                            </Box>
                            {/* <Box sx={{ width: '100%', mb: '20px' }}>
                                <Typography className="headingsGD">{t('PROGRESS')}</Typography>
                                <ProgressBar percent={(data?.parentGoalId == null || data?.parentGoalId == 0) && data?.subGoals?.length > 0 ?
                                    calculateGoalProgress(statuses) :
                                    data?.status != null ? calculateGoalProgress([data?.status]) : 0} width="100%"/>
                            </Box> */}
                            {
                                selectedSubGoal == null &&
                                <Box className={'mb20'}>
                                    <Box className={'subGoalsHeader'}>
                                        <Typography className="headingsGD">{t('SUB_GOALS')}</Typography>
                                        <ButtonDefault
                                        variant={'outlined'}
                                        value={t('ADD_SUB_GOAL')}
                                        manageOnClick={() => {setAddSubGoal(true)}}
                                        icon={<FontAwesomeIcon className={'fs13'} icon={faCirclePlus} />}
                                        disabled={isReadOnly}
                                        />
                                    </Box>
                                    {
                                        data?.subGoals && data?.subGoals?.length > 0 ?
                                        <GoalsWrapper 
                                        data={data?.subGoals} 
                                        isLoading={false} 
                                        isSubGoal={true} /> :
                                        <NoGoalsCard />
                                    }
                                </Box>
                            }
                            <Box className={'mb20'}>
                                <Typography className="headingsGD">{t('KPIS')}</Typography>
                                {
                                    !data?.kpis || data?.kpis?.length == 0 ?
                                    <Box>
                                        <ButtonDefault
                                        variant={'outlined'}
                                        value={t('ADD_KPI')}
                                        manageOnClick={() => {handleChangeKpis('addKpi', {
                                            "id": 0,
                                            "name": null,
                                            "frequency": null,
                                            "goalId": data?.id,
                                            "value": 0,
                                          }, null)}}
                                        icon={<FontAwesomeIcon className={'fs13'} icon={faCirclePlus} />}
                                        disabled={isReadOnly}
                                        />
                                    </Box> : 
                                    <KPIsTable 
                                    data={data?.kpis ? data?.kpis : []}
                                    handleChange={handleChangeKpis}
                                    handleOnBlur={updateChanges}
                                    goalId={data?.id}
                                    isDetailed={true} />
                                }
                            </Box>
                            <Box className={'mb20'}>
                                <Typography className="headingsGD">{t('PROJECTS')}</Typography>
                                {
                                    !data?.projects || data?.projects?.length == 0 ?
                                    <Box>
                                        <ButtonDefault
                                        variant={'outlined'}
                                        value={t('ADD_PROJECT')}
                                        manageOnClick={() => {setAddProject(true)}}
                                        icon={<FontAwesomeIcon className={'fs13'} icon={faCirclePlus} />}
                                        disabled={isReadOnly}
                                        />
                                    </Box> : 
                                    <GoalProjectsTable 
                                    data={data?.projects ? data?.projects : []}
                                    isLoading={isFetchingProjects}
                                    manageProjects={handleChangeProjects}
                                    addProject={() => {setAddProject(true)}}/>
                                }
                            </Box>
                        </Box>
                    </Box>
                    <Box className={'dividerLine'} />
                    <Box className={'gdRightContent'}>
                        <Box className={'gdRightContentWrapper'}>
                            <Typography className="headingsGD mb20">{t('DETAILS')}</Typography>
                            <Box className={'mb10 rightSectionGrids'}>
                                <Typography className="headingsGDright">{t('TIME_PERIOD')}</Typography>
                                <YearFromTo 
                                fromDate={data?.yearFrom} 
                                toDate={data?.yearTo} 
                                manageSelect={handleChangeState}
                                manageOnBlur={updateChanges}
                                ml={'0px'} 
                                isReadOnly={isReadOnly}/>
                            </Box>
                            <Box className={'mb10 rightSectionGrids'}>
                                <Typography className="headingsGDright">{t('DEPARTMENT')}</Typography>
                                <DepartmentSelectBox value={data?.departmentId} manageSelect={handleChangeState} isReadOnly={isReadOnly} hideLabel={true} ml={'0px'} width={'-webkit-fill-available'} />
                            </Box>
                            <Box className={'mb10 rightSectionGrids'}>
                                <Typography className="headingsGDright">{t('PRIVACY')}</Typography>
                                <PrivacySelector value={data?.privacy} manageSelect={handleChangeState} manageOnBlur={updateChanges}  isRequired={true} isReadOnly={isReadOnly} width={'-webkit-fill-available'} />
                            </Box>
                            {
                                data?.privacy && !isAdmin ?
                                <Box className={'mb10 rightSectionGrids'}>
                                    <Typography className="headingsGDright">{t('SHOW_JL')}</Typography>
                                    <SwitchButton
                                        label={''} isOn={data?.showToJL}
                                        handleOnClick={() => {handleChangeState({...data, showToJL: !data.showToJL})}}/>
                                </Box> : null
                            }
                            <Box className={'mb10 rightSectionGrids'}>
                                <Typography className="headingsGDright">{t('OWNER')}</Typography>
                                <AvatarOwnerSelectBox 
                                value={data?.ownerId} 
                                manageSelect={handleChangeState} 
                                hideLabel={true}
                                manageOnBlur={updateChanges}
                                isRequired={true}
                                ml={'0px'}
                                width={'-webkit-fill-available'}
                                isReadOnly={(data?.parentGoalId || isReadOnly) ? true : false} />
                            </Box>
                            <Box className={'mb10 rightSectionGrids'}>
                                <Typography className="headingsGDright">{t('Members')}</Typography>
                                <StaffMultiSelectCheckBoxWithoutBorders
                                selectedList={data?.members}
                                manageChange={handleChangeState}
                                manageOnFocus={(e:any) => e.stopPropagation()}
                                manageOnBlur={updateChanges}
                                overrideList={selectedSubGoal == null ? null : selectedGoal?.members ? selectedGoal?.members : []}
                                isReadOnly={isReadOnly}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            }
        </>
    )
}

export default GoalDetails;